import { Component, OnDestroy, OnInit } from "@angular/core";
import { AssessmentService } from "../shared/services/assessment.service";
import { ViewStateService } from "../../shared/services/view-state.service";
import { Question } from "../shared/models/question";
import { UserService } from "../../shared/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Assessment } from "../shared/models/assessment";
import { NotificationsService } from "../../shared/services/notifications.service";
import moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-question-answer",
  templateUrl: "./question-answer.component.html",
  styleUrls: ["./question-answer.component.css"],
})
export class QuestionAnswerComponent implements OnInit, OnDestroy {
  question: Question;
  personId: string;
  assessmentId: string;
  questionId: string;
  assessment: Assessment;
  selectedAnswer: string;
  isAnswerCorrect: boolean;
  currentYear: string;
  private destroy$ = new Subject<void>();

  constructor(
    private assessmentService: AssessmentService,
    private viewState: ViewStateService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private notifications: NotificationsService
  ) {
    this.question = new Question();
  }

  ngOnInit() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.viewState.startLoading();
    this.personId = this.userService.CurrentUser.personId;
    this.selectedAnswer = this.assessmentService.getSelectedAnswer();
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.questionId = params["questionId"];
      this.assessmentId = params["assessmentId"];
      this.assessment = this.assessmentService.getAssessmentObj(
        this.assessmentId
      );
      this.getQuestionDetails(this.questionId);
    });
    this.currentYear = moment(new Date()).format("YYYY");
  }

  nextQuestion() {
    this.assessmentService.destroyQuestion();
    this.assessmentService.getAssessmentObj(this.assessmentId);
    if (this.question.nextQuestionId) {
      this.router.navigate([
        "assessment/" +
          this.assessmentId +
          "/rules/" +
          this.question.nextQuestionId,
      ]);
    } else {
      this.notifications.success(
        "Completed",
        "Assessment is completed successfully"
      );
      this.router.navigate(["/"]);
    }
  }

  private getQuestionDetails(questionId) {
    this.assessmentService
      .getQuestionDetails(this.personId, questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.question = res;
          const correctOption = this.question.options.find(
            (option) => option.isAnswer === true && option.isSelectedOption
          );
          this.isAnswerCorrect = !!correctOption;
          this.viewState.stopLoading();
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
        }
      );
  }

  private handleServerErrorResponse(response) {
    if (response.status === 500)
      this.notifications.error(
        "Unexpected Error",
        "An unexpected error occurred. Please try again or contact NBRC for assistance."
      );
    else {
    }
    this.viewState.stopLoading();
  }

  blockCopy() {
    this.assessmentService
      .warnUser(this.personId, "copy", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  blockCut() {
    this.assessmentService
      .warnUser(this.personId, "cut", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
